<tlk-card [padding]="24">
	<div tlkCardContent>
		<div class="dentures__container">
			<div class="dentures__header">
				<h2 class="dentures__title">{{ 'FlexibleRxProcedure.DenturesCard' | translate }}</h2>
				<div class="dentures__arch-toggles">
					<tlk-slide-toggle
						class="dentures__arch-toggles-item"
						[formControl]="isUpperControl"
						[id]="'isUpper'"
						name="isUpperControl"
						labelPosition="left"
						[isDisabled]="(dentureUpperSectionIsReadonly$ | async) || (isReadOnly$ | async) || false"
						(disableChangeEvent)="switchOffControl($event, isUpperControl)"
					>
						{{ 'DentureDetails.UpperDentureTitle' | translate }}
					</tlk-slide-toggle>

					<tlk-slide-toggle
						class="dentures__arch-toggles-item"
						[formControl]="isLowerControl"
						[id]="'isLower'"
						name="isLowerControl"
						labelPosition="left"
						[isDisabled]="(dentureLowerSectionIsReadonly$ | async) || (isReadOnly$ | async) || false"
						(disableChangeEvent)="switchOffControl($event, isLowerControl)"
					>
						{{ 'DentureDetails.LowerDentureTitle' | translate }}
					</tlk-slide-toggle>
				</div>
			</div>

			<div class="dentures__form">
				<rx-procedure-type-control class="dentures__form-field" [id]="'type'"></rx-procedure-type-control>

				<rx-select
					class="dentures__form-field"
					[id]="'stage'"
					[label]="'DentureDetails.StageTitle' | translate"
					[formControl]="stageControl"
					[options]="stages$ | async"
					[isDisabled]="(isReadOnly$ | async) || false"
					[isCancellable]="true"
					(disableChangeEvent)="cleanControlWhenDisabled($event, stageControl)"
					name="stageControl"
				></rx-select>

				<rx-select
					class="dentures__form-field"
					[id]="'mould'"
					[label]="'DentureDetails.MouldTitle' | translate"
					[formControl]="mouldControl"
					[options]="moulds$ | async"
					[isDisabled]="(isReadOnly$ | async) || false"
					[isCancellable]="true"
					(disableChangeEvent)="cleanControlWhenDisabled($event, mouldControl)"
					name="mouldControl"
				></rx-select>

				<rx-select
					class="dentures__form-field"
					[id]="'shadeSystem'"
					[label]="'DentureDetails.ShadeSystemTitle' | translate"
					[formControl]="shadeSystemControl"
					[options]="shadeSystems"
					[isDisabled]="(isReadOnly$ | async) || false"
					[isCancellable]="false"
					[isRequired]="(shouldValidateForSend$ | async) || false"
					name="shadeSystemControl"
				></rx-select>

				<rx-string-selector
					class="dentures__form-field"
					*ngIf="teethShadesHasOptions$ | async"
					[id]="'teethShade'"
					[label]="'DentureDetails.TeethShadeTitle' | translate"
					[formControl]="teethShadeControl"
					[options]="teethShades$ | async"
					name="teethShadeControl"
					[isDisabled]="!isTeethShadeEnabled"
					[isReadOnly]="(isReadOnly$ | async) || false"
					[isCancellable]="true"
					[isRequired]="(shouldValidateForSend$ | async) || false"
				></rx-string-selector>

				<rx-select
					class="dentures__form-field"
					[id]="'gingivalShade'"
					[label]="'DentureDetails.GingivalShadeTitle' | translate"
					[formControl]="gingivalShadeControl"
					[options]="gingivalShades$ | async"
					[isDisabled]="(isReadOnly$ | async) || false"
					[isCancellable]="true"
					[isRequired]="(shouldValidateForSend$ | async) || false"
					name="gingivalShadeControl"
				></rx-select>
			</div>
		</div>
	</div>
</tlk-card>
